import React, { useCallback, useEffect, useRef } from 'react';
import { Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { VariableSizeList as LoadDataList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useWindowResize } from '../../utility/useWindowResize';
import ParticipantPoPUpRow from './participantPopUpRow';

const theme = createTheme();
const useStyles = makeStyles(() => ({
    cardPaperContent: {       
       // boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1, 1, 1, 0),
        backgroundColor: '#fff',
    },
  cardContent: {
    '&:last-child': {
        paddingBottom: theme.spacing(0),
    },
  },
  cardRowContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
},
headRowContent: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    width: '100%',
    alignItems: 'center',
},
wrapAll: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '20ch',
},
}));

const ParticipantPopUpWindowDataList = (props) => {
  const classes = useStyles();
  const { data } = props;
  const listRef = useRef();
  const sizeMap = useRef({});

  const setSize = useCallback((index, size) => {
    sizeMap.current[index] = size;
    listRef.current.resetAfterIndex(index);
  }, []);

  const getSize = index => sizeMap.current[index] || 60;
  const [windowWidth] = useWindowResize();

  const Row = ({ index, style }) => {
    const item = data[index];

    useEffect(() => {
      setSize(index, style.height);
    }, [setSize, index, style.height, windowWidth]);

    return (
      <Card sx={{ 
        width: '100%',
        boxShadow:'unset',
        m: 0,
        }} 
        style={{
          height: style && style.height >= 45 ? 60 : style.height,
          left: style.left,
          position: style.position,
          right: style.right,
          top: style.top,
          width: style.width,
        }}>
        <CardContent className={classes.cardContent} sx={{ m: 0, p: 0,}}>
          <ParticipantPoPUpRow
            classes={classes}
            item={item}
            index={index}
            {...props}
          />
        </CardContent>
      </Card>
    );
  };

  return (
<div style={{ display: 'flex',height:'50vh',padding:'8px 0px' }}>
    <div style={{ flex: '1 1 auto' }}>
    <AutoSizer>
      {({ height, width }) => (
        <LoadDataList
          ref={listRef}
          itemData={data}
          className="List"
          height={height}
          itemCount={data.length}
          itemSize={getSize}
          width={width}
        >
          {Row}

        </LoadDataList>
      )}
    </AutoSizer>
    </div>
</div>
  );
};

export default ParticipantPopUpWindowDataList;
